import { Component } from '@angular/core';
import { PromptUpdateService} from "../app/prompt-update.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent {
  title = 'SmartMate';
  constructor(sw: PromptUpdateService){
    // check for app updates
    sw.checkForUpdates();
  }
}
